<template>

    <v-container>
        <h1>En Mantenimiento</h1>
    </v-container>
    <!--
<v-container>

    <u-animate-container>
        <u-animate name="bounceInRight" delay="0s" duration="2s" :iteration="1" :offset="0" animateClass="animated" :begin="false">
            <v-flex xs12>
                <v-container>
                    <v-layout row wrap>
                        <v-flex sm12 xs12 md6 lg6 pa-1>
                            <card class="v-card--material-stats">
                                <v-card slot="offset" :class="`elevation-10`" color="green" class="pa-4" dark >
                                    <v-icon size="40" >
                                        mdi-file-multiple
                                    </v-icon>
                                </v-card>
                                <div class="text-xs-right">
                                    <p :class="estado_solvencia || estado_solvencia_mes_gracia ? 'green--text' : 'red--text'" class="category font-weight-light" v-text="estado_solvencia || estado_solvencia_mes_gracia ? 'SOLVENTE' : 'DEUDA PENDIENTE'" />
                                    <v-btn :loading="loading" small v-if="(estado_solvencia && !inactive_logica) || (estado_solvencia_mes_gracia && !inactive_logica)" color="primary" dark class="mb-2" @click="downloadSolvencia('SOLVENCIA')">Descargar Solvencia</v-btn>
                                    <v-btn :loading="loading" small v-if="(!estado_solvencia && !inactive_logica) || (!estado_solvencia_mes_gracia && !inactive_logica)" color="primary" dark class="mb-2" @click="payActivate = true">{{ diferencia_pago ? 'Pagar Diferencia' : 'Pagar cuotas'  }}</v-btn>
                                </div>
                                <template slot="actions">
                                    <span class="caption font-weight-light" />
                                </template>
                            </card>
                        </v-flex>
                        <v-flex sm12 xs12 md6 lg6 pa-1>
                            <card class="v-card--material-stats">
                                <v-card slot="offset" :class="`elevation-10`" color="blue" class="pa-4" dark >
                                    <v-icon size="40" >
                                        mdi-file-multiple
                                    </v-icon>
                                </v-card>
                                <div class="text-xs-right">
                                    <p class="category font-weight-light" v-text="'CARTAS DESCARGABLES'" />
                                    <v-layout align-center justify-end row fill-height>
                                        <v-flex xs12 md4 lg4 pa-1 >
                                            <v-btn small v-if="estado_solvencia || estado_solvencia_mes_gracia" color="primary" dark class="mb-2" @click="downloadSolvencia('INSCRIPCION')">Carta de Inscripción</v-btn>
                                        </v-flex>
                                        <v-flex xs12 md4 lg4 pa-1 >
                                            <v-btn small v-if="estado_solvencia || estado_solvencia_mes_gracia" color="primary" dark class="mb-2" @click="downloadSolvencia('DEONTOLOGICA')">Carta Deontológica</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </div>
                                <template slot="actions">
                                    <span class="caption font-weight-light" />
                                </template>
                            </card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </u-animate>
    </u-animate-container>

    <v-layout>
        <v-flex xs12>
            <v-card min-height="200px">
                <v-container>
                    <v-layout row wrap justify-center>

                        <v-flex xs12 md6 lg6>
                            <v-scroll-y-transition mode="out-in" v-if="!inactive_logica">
                                <v-data-table
                                    v-if="!estado_solvencia && !estado_solvencia_pendiente"
                                    :items="invoicecuota"
                                    class="elevation-0"
                                    hide-actions
                                    :headers="headerscuotas"
                                    :expand="expand"
                                    no-data-text=""
                                    item-key="code"
                                >
                                    <template v-slot:items="props">
                                        <tr>
                                            <td>{{ props.item.concepto == 'CUOTA EXTRAORDINARIA MES ANIVERSARIO' ? 13 : props.item.cuota_concepto }}</td>
                                            <td>{{ props.item.concepto }}</td>
                                            <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(props.item.amount).toFixedDown(2)) }} Bs</td>
                                        </tr>
                                    </template>
                                    <template v-slot:footer>
                                        <tr>
                                            <td colspan="2">
                                                <strong>Sub-Total</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong>{{ new Intl.NumberFormat("de-DE").format(parseFloat(subTotal).toFixedDown(2)) }} BsS</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <strong>IVA</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong>{{ new Intl.NumberFormat("de-DE").format(parseFloat(iva).toFixedDown(2)) }} BsS</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <strong>Total</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong>{{ new Intl.NumberFormat("de-DE").format(parseFloat(total).toFixedDown(2)) }} BsS</strong>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                                <div v-if="!estado_solvencia && estado_solvencia_pendiente">
                                    <v-card>
                                        <v-card-title>
                                            <div>
                                                <span class="grey--text">Factura Pendiente</span><br>
                                                <span>RIF: {{ invoice.rif }}</span><br>
                                                <span>Razon Social: {{ invoice.razon_social }}</span><br>
                                                <span>Monto: {{ invoice.amount }}</span>
                                            </div>
                                        </v-card-title>
                                    </v-card>
                                </div>
                            </v-scroll-y-transition>
                        </v-flex>
                        <v-flex xs12 md4 lg4 offset-md1 offset-lg1 v-if="posee_pagos">
                            <v-card>
                                <v-list two-line>
                                    <template>
                                        <div v-for="(item, index) in invoice.payments" :key="item.id">
                                            <v-list-tile ripple>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>Pago {{ index + 1 }}</v-list-tile-title>
                                                    <v-list-tile-sub-title class="text--primary" v-if="item.observations != null">{{ item.observations }}</v-list-tile-sub-title>
                                                    <v-list-tile-sub-title>por {{ new Intl.NumberFormat("de-DE").format(item.amount) }} BsS</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-list-tile-action-text>{{ item.observations != null && item.agreement == false ? 'RECHAZADO' : item.observations != null && item.agreement ? 'APROBADO' : 'PENDIENTE' }}</v-list-tile-action-text>
                                                    <v-icon :color="item.observations != null && item.agreement == false ? 'red darken-2' : item.observations != null && item.agreement ? 'green darken-2' : 'yellow darken-2'">
                                                        star
                                                    </v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                            <v-divider
                                                v-if="index + 1 < item.length"
                                                :key="index"
                                            ></v-divider>
                                        </div>
                                    </template>
                                </v-list>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
            xxxx
            <v-card min-height="200px">
                <v-container>
                    <v-layout row wrap justify-center>

                        <v-flex xs12 md6 lg6>
                            <v-scroll-y-transition mode="out-in" v-if="!inactive_logica">
                                <v-data-table
                                    v-if="!estado_solvencia && !estado_solvencia_pendiente"
                                    :items="invoice"
                                    class="elevation-0"
                                    hide-actions
                                    :headers="headers"
                                    :expand="expand"
                                    no-data-text=""
                                    item-key="code"
                                >
                                    <template v-slot:items="props">
                                        <tr>
                                            <td>{{ props.item.concepto == 'CUOTA EXTRAORDINARIA MES ANIVERSARIO' ? 13 : props.item.cuota }}</td>
                                            <td>{{ props.item.concepto }}</td>
                                            <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(props.item.amount).toFixedDown(2)) }} Bs</td>
                                        </tr>
                                    </template>
                                    <template v-slot:footer>
                                        <tr>
                                            <td colspan="2">
                                                <strong>Sub-Total</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong>{{ new Intl.NumberFormat("de-DE").format(parseFloat(subTotal).toFixedDown(2)) }} BsS</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <strong>IVA</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong>{{ new Intl.NumberFormat("de-DE").format(parseFloat(iva).toFixedDown(2)) }} BsS</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <strong>Total</strong>
                                            </td>
                                            <td class="text-xs-right">
                                                <strong>{{ new Intl.NumberFormat("de-DE").format(parseFloat(total).toFixedDown(2)) }} BsS</strong>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                                <div v-if="!estado_solvencia && estado_solvencia_pendiente">
                                    <v-card>
                                        <v-card-title>
                                            <div>
                                                <span class="grey--text">Factura Pendiente</span><br>
                                                <span>RIF: {{ invoice.rif }}</span><br>
                                                <span>Razon Social: {{ invoice.razon_social }}</span><br>
                                                <span>Monto: {{ invoice.amount }}</span>
                                            </div>
                                        </v-card-title>
                                    </v-card>
                                </div>
                            </v-scroll-y-transition>
                        </v-flex>
                        <v-flex xs12 md4 lg4 offset-md1 offset-lg1 v-if="posee_pagos">
                            <v-card>
                                <v-list two-line>
                                    <template>
                                        <div v-for="(item, index) in invoice.payments" :key="item.id">
                                            <v-list-tile ripple>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>Pago {{ index + 1 }}</v-list-tile-title>
                                                    <v-list-tile-sub-title class="text--primary" v-if="item.observations != null">{{ item.observations }}</v-list-tile-sub-title>
                                                    <v-list-tile-sub-title>por {{ new Intl.NumberFormat("de-DE").format(item.amount) }} BsS</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-list-tile-action-text>{{ item.observations != null && item.agreement == false ? 'RECHAZADO' : item.observations != null && item.agreement ? 'APROBADO' : 'PENDIENTE' }}</v-list-tile-action-text>
                                                    <v-icon :color="item.observations != null && item.agreement == false ? 'red darken-2' : item.observations != null && item.agreement ? 'green darken-2' : 'yellow darken-2'">
                                                        star
                                                    </v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                            <v-divider
                                                v-if="index + 1 < item.length"
                                                :key="index"
                                            ></v-divider>
                                        </div>
                                    </template>
                                </v-list>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>




    

    <v-dialog v-model="loading" hide-overlay persistent width="300">
        <v-card color="primary" dark>
            <v-card-text>
                Porfavor Espere...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

        <v-dialog v-model="payActivate" width="600" persistent>
            <v-flex xs12>
            <v-card>
                <v-form ref="formpago" v-model="validpago" lazy-validation>
                    <v-card-title>
                        <h3 class="headline mb-0"><span style="color: #9C1A1A">Efectuar Pago</span></h3>
                    </v-card-title>
                   <v-card-text>

                    <v-flex xs12 align-center justify-space-between>
                        <v-layout align-center>
                            <v-flex xs12 sm4>
                                <v-text-field
                                    disabled
                                    ref="rif"
                                    v-model="form.rif"
                                    prepend-icon="featured_video"
                                    label="RIF"
                                    :rules="[v => !!v || 'RIF es requerido']"
                                    required
                                    mask="A-########-#"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm8>
                                <v-text-field
                                    disabled
                                    ref="razonsocial"
                                    v-model="form.razon_social"
                                    prepend-icon="person"
                                    label="Razon social"
                                    :rules="[v => !!v || 'Razon social es requerido']"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field
                            ref="direccionfiscal"
                            v-model="form.direccion_fiscal"
                            prepend-icon="domain"
                            label="Direccion Fiscal"
                            :rules="[v => !!v || 'Direccion Fiscal es requerido']"
                            required
                        ></v-text-field>
                    </v-flex>

                        <v-flex xs12>
                           <ul>
                                <li>Por favor proceda a realizar el pago en la siguiente cuenta bancaria:</li>
                                <li>BANESCO</li>
                                <li>A nombre del: Colegio de Contadores Públicos Distrito Capital</li>
                                <li>Rif: J-00066535-4 </li>
                                <li>Cuenta Corriente: 0134-0038-5103-8307-5688</li>
                            </ul>
                        </v-flex>
                        <br>
                        <hr>
                        <v-flex xs12 align-center justify-space-between>
                                    <v-flex xs12 sm6>
                                        <v-select
                                            prepend-icon="account_balance_wallet"
                                            :items="wayToPay"
                                            v-model="form.way_to_pay"
                                            @change="changeWayToPay"
                                            label="Método de pago"
                                            :rules="[v => !!v || 'Método de pago es requerido']"
                                            required
                                        ></v-select>
                                    </v-flex>


                            <v-layout align-center>

                                        <v-flex xs12 sm6>
                                            <v-text-field 
                                                v-model="form.cuota_limit" 
                                                type="number" 
                                                :label="`Limite de Cuotas ${invoicecuota.length -1}`" 
                                                append-outer-icon="add" 
                                                @click:append-outer="incrementLimits" 
                                                prepend-icon="remove" 
                                                :min="1"
                                                @change="cambioSalesLimit"
                                                @click:prepend="decrementLimits">
                                            </v-text-field>
                                        </v-flex>  

                                <v-flex xs12 sm6>
                                    <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                                        <div class="v-input__prepend-outer">
                                        <div class="v-input__icon v-input__icon--prepend">
                                            <i aria-hidden="true" class="v-icon material-icons theme--light">credit_card</i>
                                        </div>
                                        </div>
                                        <div class="v-input__control">
                                        <div class="v-input__slot">
                                            <div class="v-text-field__slot">
                                            <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto a pagar</label>
                                            <vue-numeric read-only currency="BsS" :value="form.amount" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                                            </div>
                                        </div>
                                        <div class="v-text-field__details">
                                            <div class="v-messages theme--light">
                                            <div class="v-messages__wrapper">
                                                Precio con IVA + SERVICIO incluido
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <v-select
                                v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                prepend-icon="account_balance"
                                :items="banks"
                                v-model="form.bank_id"
                                item-text="name"
                                item-value="id"
                                label="Banco"
                                :rules="[v => !!v || 'Banco de pago es requerido']"
                                required
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                        ref="number"
                                        v-model="form.number"
                                        prepend-icon="remove"
                                        label="Número de transacción"
                                        mask="###############"
                                        :rules="[v => !!v || 'Número de transacción es requerido']"
                                        required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-menu
                                        ref="menu"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="menu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        min-width="290px"
                                        :return-value.sync="date"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            label="Fecha"
                                            v-model="computedDateFormattedFecha"
                                            hint="DD/MM/YYYY formato"
                                            prepend-icon="event"
                                            :rules="[v => !!v || 'Fecha es requerido']"
                                            required
                                            readonly
                                        ></v-text-field>
                                        <v-date-picker :max="new Date().toISOString().slice(0,10)" v-model="form.payment_date" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <input hidden type="file" ref="fileInput" @change="processFile($event)">
                            <v-text-field
                                :rules="[v => !!v || 'Comprobante de pago es requerido']"
                                ref="document"
                                v-model="nameImg"
                                @click.native="onFocus"
                                prepend-icon="attach_file"
                                label="Comprobante de pago"
                            ></v-text-field>
                        </v-flex>

                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary darken-1" @click="closePay">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :loading="loading" color="primary" @click="confirmData">Confirmar Pago</v-btn>
                </v-card-actions>
                </v-form>
            </v-card>
        </v-flex>
        </v-dialog>

</v-container>
-->
</template>


<script>
import Form from 'vform'
import axios from 'axios'
import VueNumeric from 'vue-numeric'
import { mapGetters } from 'vuex'
import { UAnimateContainer, UAnimate } from 'vue-wow'
import statscard from '~/components/material/StatsCard.vue'
import Card from '~/components/material/Card.vue'
import VueNumericInput from 'vue-numeric-input'

Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {

    name: "solvencia-servicios-view",

    components: {
        UAnimateContainer,
        UAnimate,
        Card,
        statscard,
        VueNumeric,
        VueNumericInput
    },

    data () {
      return {
        estado_solvencia_mes_gracia: false,
        sp_deleted: false,
        expand: false,
        diferencia_pago: false,
        posee_pagos: false,
        date: null,
        fecha: null,
        menu: false,
        validpago: false,
        estado_solvencia: null,
        estado_solvencia_pendiente: false,
        dialog: false,
        loading: false,
        inactive_logica: false,
        payActivate: false,
        acumulado_pagos: 0.00,
        total: 0.00,
        subTotal: 0.00,
        iva: 0.00,
        invoice: [],
        invoicecuota: [],
        banks: [],
        wayToPay: ['TRANSFERENCIA'],
        nameImg: '',
        headerscuotas: [
            { text: 'CUOTA', value: '', sortable: false },
            { text: 'ITEM', value: '', sortable: false },
            { text: 'MONTO', value: '', sortable: false, align: 'right' },
        ],
        headers: [
            { text: 'CUOTA', value: '', sortable: false },
            { text: 'ITEM', value: '', sortable: false },
            { text: 'MONTO', value: '', sortable: false, align: 'right' },
        ],
        form: new Form({
            cpc: '',
            way_to_pay: 'TRANSFERENCIA',
            number: null,
            ruap_id: null,
            amount: 0.00,
            cuota_limit: 1,
            rif: '',
            razon_social: '',
            direccion_fiscal: '',
            payment_date: '',
            observations: '',
            file: '',
            document: '',
            agreement: false
        }),
      }
    },

    computed: {
        ...mapGetters({
            user: 'authUser'
        }),
        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date)
        }
    },

    mounted () {
        this.$store.dispatch('clearMessage')
        this.getEstadoSolvencia()
    },

    methods: {

        cambioSalesLimit() {
            //cliente/get-cuota-monto-total
            if (this.form.cuota_limit < 1) {
                this.form.cuota_limit = 1
            }
            if (this.form.cuota_limit > this.invoicecuota.length - 1) {
                this.form.cuota_limit = this.invoicecuota.length - 1
            }
            this.consultaCuotaNumCuota(this.form.cuota_limit)
        },


        incrementLimits() {
            //cliente/get-cuota-monto-total
            if (this.form.cuota_limit < this.invoicecuota.length - 1) {
                this.form.cuota_limit++
            }
            this.consultaCuotaNumCuota(this.form.cuota_limit)
        },

        decrementLimits() {
            //cliente/get-cuota-monto-total
            if (this.form.cuota_limit > 1) {
                this.form.cuota_limit--
            }
            this.consultaCuotaNumCuota(this.form.cuota_limit)
        },

        async consultaCuotaNumCuota () {
            this.loading = true
            await axios.get(`/api/cliente/get-cuota-monto-total/${this.form.cuota_limit}`)
                .then(res => {
                    this.form.amount = (parseFloat(res.data.amount) + this.servicio_admin) + this.iva
                    console.log(res.data, 'test')
                })
                .catch(error => {
                    console.log(error.response)
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Error, Intente mas Tarde'
                    })
                }).finally(() => this.loading = false);
        },

        async restablecerSolvencia() {
            this.loading = true
            await axios.post(`/api/cliente/solvencia/reset-solvencia`)
                .then(res => {
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: `Se ha restablecido la solvencia`
                    })
                    this.getEstadoSolvencia()
                })
                .catch(error => {
                    console.log(error.response)
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Error, Intente mas Tarde'
                    })
                }).finally(() => this.loading = false);  
        },

        async deleteItem(item, cantidad) {
            if (cantidad > 1) {
                this.loading = true
                let fecha = new Date(item.concept_cost.start_date).toLocaleDateString().slice(2,9)
                await axios.post(`/api/cliente/solvencia/delete-item`,{id: item.id})
                    .then(res => {
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: `Se ha eliminado el item ${item.concept_cost.concept.name} - ${fecha}`
                        })
                        this.getEstadoSolvencia()
                    })
                    .catch(error => {
                        console.log(error.response)
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: 'Error, Intente mas Tarde'
                        })
                    }).finally(() => this.loading = false);  
            }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'Debe cancelar al menos una cuota'
                })
            }
        },

        async downloadSolvencia(tipo_documento) {
            this.loading = true
            // window.open(`/api/cliente/download-solvencia/${tipo_documento}`);   
            await axios({
                    url: `/api/cliente/download-solvencia/${tipo_documento}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then(resp => {
                    const blob = new Blob([resp.data], {type: resp.data.type});
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    const contentDisposition = resp.headers['content-disposition'];
                    let fileName = 'unknown';
                    if (contentDisposition) {
                        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                        if (fileNameMatch.length === 2)
                            fileName = fileNameMatch[1];
                    }
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
            }).catch(error => {
                console.log(error.response)
                if(error.response.data.descarga){
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: error.response.data.descarga
                    })
                } else {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Error, Intente descargar mas tarde'
                    })
                }
            }).finally(() => this.loading = false);         
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        getEstadoSolvencia() {
            this.loading = true;
                axios.get(`/api/cliente/estado-solvencia`)
                    .then(res => {
                        // console.log(res.data)
                        if (res.data.condition == "EXONERADO") {
                            this.estado_solvencia = true
                            this.estado_solvencia_mes_gracia = true
                        }else{
                            this.form.rif = this.user.rif
                            this.form.razon_social = this.user.name
                            this.form.direccion_fiscal = this.user.direccion_fiscal
                            this.banks = res.data.banks
                            let total_payments = 0

                            let solvente_hasta = res.data.solvente_hasta
                            let fecha_actual = new Date();
                            let fecha = fecha_actual;

                            if (solvente_hasta != "") {
                                fecha = new Date(solvente_hasta[0].solvente_hasta)
                                
                                if (fecha > fecha_actual) {
                                    this.estado_solvencia_mes_gracia = true
                                }else {
                                    this.estado_solvencia_mes_gracia = false
                                }
                            }else if (solvente_hasta == "" || solvente_hasta == null) {
                                this.estado_solvencia_mes_gracia = true
                            }else {
                                this.estado_solvencia_mes_gracia = false
                            }
                            this.inactive_logica = false
                            this.servicio_admin_object = res.data.concept_servadmon
                            this.servicio_admin = parseFloat(this.servicio_admin_object.amount)
                            let iva_serv_admin = 0
                            iva_serv_admin = parseFloat(this.servicio_admin * 0.16);
                            if (res.data.solvencia) {
                                if (res.data.existe_deuda.length == 0) {
                                    this.estado_solvencia = true
                                     if (res.data.invoice_pagada == null) {
                                        this.estado_solvencia = false
                                        this.inactive_logica = true
                                    }
                                }else {
                                    this.invoice = res.data.existe_deuda
                                    this.invoicecuota = res.data.existe_deuda_cuota
                                    this.invoice.push({
                                        amount: this.servicio_admin,
                                        concept_cost_id: this.servicio_admin_object.id,
                                        cuota: this.servicio_admin_object.code,
                                        concepto: this.servicio_admin_object.name
                                    })
                                    console.log(this.servicio_admin_object,'serv')
                                    this.invoicecuota.push({
                                        amount: this.servicio_admin,
                                        concept_cost_id: this.servicio_admin_object.id,
                                        cuota: null,
                                        concepto: this.servicio_admin_object.concepto
                                    })
                                    this.estado_solvencia = false
                                    this.estado_solvencia_pendiente = false
                                    this.iva = iva_serv_admin
                                    this.total = parseFloat(res.data.total) + this.servicio_admin
                                    console.log('paso', this.invoicecuota)

                                    this.form.cuota_limit = this.invoicecuota.length - 1

                                    this.consultaCuotaNumCuota(this.form.cuota_limit)
                                    // let indice = this.form.cuota_limit;
                                    // this.form.amount = 0
                                    // for (let index = 0; index < indice; index++) {
                                    //     this.form.amount = parseFloat(this.form.amount + parseFloat(this.invoicecuota[index].amount))
                                    // }
                                    // this.form.amount = parseFloat(this.form.amount + this.servicio_admin) + this.iva//

                                    this.subTotal = this.total
                                    this.total = parseFloat(this.total + this.iva)
                                }
                            }else {
                                if (res.data.invoice == null) {
                                    if (res.data.invoice_pagada == null) {
                                        this.inactive_logica = true
                                        this.estado_solvencia = false
                                    }
                                }else {
                                  if(res.data.invoice.payments.length != 0){
                                        this.posee_pagos = true
                                        this.diferencia_pago = true
                                        res.data.invoice.payments.forEach(e => {
                                            if(e.agreement){
                                                total_payments += parseFloat(e.amount)
                                            }
                                        });
                                        this.acumulado_pagos = parseFloat(total_payments)
                                    }else {
                                        this.posee_pagos = false
                                    }
                                    this.invoice = res.data.invoice
                                    this.estado_solvencia = false
                                    this.estado_solvencia_pendiente = true
                                    this.iva = iva_serv_admin
                                    this.total = parseFloat(res.data.invoice.amount)
                                    this.form.amount = parseFloat(this.total + this.iva)
                                    this.subTotal = this.total
                                    this.total = parseFloat(this.total + this.iva)
                                }
                            }

                        

                            // if(this.diferencia_pago) {
                            //     this.form.amount = this.total - this.acumulado_pagos
                            // }else {
                            //     this.form.amount = this.total
                            // }
                        }

                    })
                    .catch(error => {
                        this.inactive_logica = true
                        console.log(error.response)
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: 'Error, Intente mas Tarde'
                        })
                    })
                    .finally(() => this.loading = false);
        },

        async confirmData () {
            if (this.$refs.formpago.validate()) {
                this.loading = true
                let formData = new FormData();
                for (var key in this.form) {
                    formData.append(key, this.form[key]);
                }
                await axios.post(`/api/cliente/ap-pay-solvencia`,formData)
                    .then(res => {
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: 'Carga de pago Exitosa!..'
                        })
                        this.getEstadoSolvencia()
                        this.closePay()
                    })
                    .catch(error => {
                        console.log(error.response)
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: 'Error, Intente mas Tarde'
                        })
                    })
                this.$nextTick(() => {
                    this.loading = false
                })
            }
        },

        onChange () {
            this.getEstadoSolvencia();
        },

        async changeWayToPay() {
            if(this.form.way_to_pay == 'EFECTIVO - MONEDA LOCAL'){
                this.form.number = null
            }
            if(this.form.way_to_pay == 'EFECTIVO - DIVISAS'){
                this.form.number = null
            }
        },

        async efectuarPago(props) {
            this.loading = true
            await axios.get(`/api/cliente/security-paper-mount`)//cambiar metodo para consultar saldo restante
                .then(resp => {
                    let precio = parseFloat(resp.data.amount)
                    let tax = resp.data.t_amount == null ? 0 : parseFloat(resp.data.t_amount)
                    let monto_cantidad = props.item.cantidad * precio
                    let monto_imp = 0
                    if(tax == 0){
                        monto_imp = 0
                    }else {
                        monto_imp = (tax / 100) * monto_cantidad
                    }
                    let monto_total = monto_cantidad + monto_imp
                    let diff_total = this.montoDiferenciaPago2(props)
                    
                    this.form = {
                        invoice_id: props.item.invoice.id,
                        cpc: props.item.cpc,
                        amount: (monto_total - diff_total),
                        way_to_pay: 'TRANSFERENCIA',
                    }

                    this.$refs.formpago.resetValidation()
                    this.payActivate = true

                }).catch(err => {
                    console.log(err.response)
                    this.$refs.formpago.resetValidation()
                    this.payActivate = false
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Error Servidor, Intente su pago mas tarde.'
                    })
                }).finally(() => this.loading = false)
        },

        onFocus() {
            this.$refs.fileInput.value = ''
            this.$refs.fileInput.click()
        },

        processFile(event) {
            let files = event.target.files || event.dataTransfer.files
            if (files[0].type == "image/png" || files[0].type == "image/jpg" || files[0].type == "image/jpeg" || files[0].type == "application/pdf") {
                this.form.file = files[0]
                this.nameImg = files[0].name
            }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'El formato del documento debe ser PNG/JPG/JPEG o PDF'
                })
            }
        },

        async closePay() {
            let amount = this.form.amount
            let cuota_limit = this.form.cuota_limit
            this.form = {
                way_to_pay: 'TRANSFERENCIA',
                number: null,
                ruap_id: null,
                payment_date: '',
                observations: '',
                cuota_limit: cuota_limit,
                amount: amount,
                agreement: false
            }
            this.payActivate = false
            this.form.rif = this.user.rif
            this.form.razon_social = this.user.name
            this.form.direccion_fiscal = this.user.direccion_fiscal
        },

        async responseForm(){
            this.getEstadoSolvencia();
        }

    }

  }
</script>

<style lang="scss">
.v-card--material-stats {
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: auto;
    padding: 0 16px 0;
  }

  .v-card {
    border-radius: 4px;
    flex: 0 1 auto;
  }

  .v-card__text {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }

  .v-card__actions {
    flex: 1 0 100%;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/cliente/SolvenciaServicios.vue